/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IVitals } from 'app/shared/model/vitals.model';
import { ILabPrescription } from 'app/shared/model/lab-prescription.model';
import { Thyroid } from 'app/shared/model/enumerations/thyroid.model';
import { TypeOfAnaesthesia } from 'app/shared/model/enumerations/type-of-anaesthesia.model';
import { ASACategory } from 'app/shared/model/enumerations/asa-category.model';

export interface IPreOpAssessment {
  id?: string;
  surgeryDateTime?: number;
  hypertension?: boolean;
  diabetes?: boolean;
  asthma?: boolean;
  allergy?: boolean;
  epilepsy?: boolean;
  ihd?: boolean;
  thyroid?: keyof typeof Thyroid | null;
  previousSurgeyInfo?: string | null;
  historyOfTB?: string | null;
  otherHistory?: string | null;
  icterus?: boolean;
  pallor?: boolean;
  lymphadenopathy?: string | null;
  edema?: boolean;
  airwayDentition?: string | null;
  thyroidText?: string | null;
  spine?: string | null;
  mallampatiGrade?: string | null;
  tmDistance?: string | null;
  cvs?: string | null;
  respiratorySystem?: string | null;
  git?: string | null;
  cns?: string | null;
  otherFindings?: string | null;
  psychologicalNeeds?: boolean;
  socialNeeds?: boolean;
  economicNeeds?: boolean;
  otherInvestigations?: string | null;
  dischargeNeeds?: string | null;
  ecg?: string | null;
  echo?: string | null;
  chestXRay?: string | null;
  typeOfAnaesthesia?: keyof typeof TypeOfAnaesthesia | null;
  aSaCategory?: keyof typeof ASACategory | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  testsIgnored?: boolean;
  surgery?: IPatientProcedure;
  anaesthesiologist?: IDoctor;
  vitals?: IVitals;
  labPres?: ILabPrescription | null;
}

export const defaultValue: Readonly<IPreOpAssessment> = {
  hypertension: false,
  diabetes: false,
  asthma: false,
  allergy: false,
  epilepsy: false,
  ihd: false,
  icterus: false,
  pallor: false,
  edema: false,
  psychologicalNeeds: false,
  socialNeeds: false,
  economicNeeds: false,
  active: false,
  testsIgnored: false,
};
